module.exports = __webpack_public_path__ + "assets/img/station28.9cdc6002.png";